export enum PwnType {
  NoticeOfIR = 5,
  Refusal = 7,
  PreSchool = 13,
  RequestForReEval = 14,
  AdditionalReEval = 15,
  RefusalReEval = 16,
  RefusalAdditionalReEval = 17,
  Mandated3YearReEval = 18,
  ParentWaiverMandated3YearReEval = 19,
  RequestAdditionalAssessments = 20,
  ParentallyPlaced = 21,
  WithdrawalInitialReferralFromSpecialEducationProcess = 22,
  Initial = 23,
  ReevaluationAnnual = 24,
  Declassification = 25,
  InitialEligibilityRecommendationIneligible = 26,
}
